import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MatDialogModule } from "@angular/material/dialog";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { KimlikBilgisiComponent } from "./kimlik-bilgisi/kimlik-bilgisi.component";
import { RandevuIslemleriComponent } from "./randevu-islemleri/randevu-islemleri.component";
import { PandemiIslemleriComponent } from "./pandemi-islemleri/pandemi-islemleri.component";
import { RandevuVerComponent } from "./randevu-ver/randevu-ver.component";
import { HastaService } from "./services/hasta.service";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { RandevulistesiComponent } from "./randevulistesi/randevulistesi.component";
import { DialogBoxComponent } from "./dialog-box/dialog-box.component";
import { TurcasoftOnlemeService } from './services/turcasoft-onleme.service';

@NgModule({
  declarations: [
    AppComponent,
    KimlikBilgisiComponent,
    RandevuIslemleriComponent,
    PandemiIslemleriComponent,
    RandevuVerComponent,
    RandevulistesiComponent,
    DialogBoxComponent,
  ],
  entryComponents: [DialogBoxComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatDialogModule,
    BrowserAnimationsModule,

  ],
  providers: [
    HastaService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TurcasoftOnlemeService,
      multi: true
    }
],
  bootstrap: [AppComponent],
})
export class AppModule {}
